import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=0dd5c5f4&scoped=true"
import script from "./trade.vue?vue&type=script&lang=js"
export * from "./trade.vue?vue&type=script&lang=js"
import style0 from "./trade.vue?vue&type=style&index=0&id=0dd5c5f4&prod&scoped=true&lang=scss"
import style1 from "./trade.vue?vue&type=style&index=1&id=0dd5c5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd5c5f4",
  null
  
)

export default component.exports